// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendationsCard-cls1_Ts0","cls2":"RecommendationsCard-cls2_TcX RecommendationsCard-cls1_Ts0"};